import locales from './locales.json';

const defaultLocale = Object.entries(locales).find((v) => v[1].default)[0];

export default Object.freeze(defaultLocale);
